import styled from "styled-components"

const ActuItem = styled.div`
  &:not(:last-child) {
    border-bottom: 5px solid ${(props) => props.theme.a_color_gradients.a_light};
  }
`

const AllBtn = styled.span`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
  border: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  background-color: ${(props) => props.theme.a_color_gradients.a_medium};
  &::after,
  &::before {
    background-color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
`

export { ActuItem, AllBtn }
